import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import ExpectingCoupleDesktopWebp from './images/working-advisor-expecting-couple.webp';
import ExpectingCoupleMobileWebp from './images/working-advisor-expecting-couple-mobile.webp';
// style imports
import { TypographyStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='working-with-an-advisor-financial-planning'
      backgroundVariant='lightC'
      moduleName='financial-planning-module'
      moduleVariation='A'
      disableBottomPadding={false}
      reverseContent={false}
      // content
      subHeadingText={<>What your first financial advisor meeting (and beyond) will <WidowBlock>be like</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            Talking about finances might not come naturally, and even if it does, your Northwestern Mutual financial advisor will be a good listener and keep the conversation easy to understand.
          </Typography>
          <BulletedList
            disableBottomPadding
            bulletedListData={[{
              bulletText: (
                <>
                  <TypographyStyled
                    variant='h4'
                    nextElement='typography'>
                    Talk about your goals and priorities
                  </TypographyStyled>
                  <Typography nextElement='typography'>
                    Your advisor will want to hear about any goals you have, where you see yourself in a year or two &#40;or ten&#41;. And if you don&#39;t have all the answers, that&#39;s ok. They&#39;ll help you figure it out.
                  </Typography>
                </>
              ),
            },
            {
              bulletText: (
                <>
                  <TypographyStyled
                    variant='h4'
                    nextElement='typography'>
                    Understand where you&#39;re starting from
                  </TypographyStyled>
                  <Typography nextElement='typography'>
                    Having your financial basics handy will be helpful. Your advisor will want to know where you are financially, no matter where that is, so they can help make the most of what you have moving forward.
                  </Typography>
                </>
              ),
            },
            {
              bulletText: (
                <>
                  <TypographyStyled
                    variant='h4'
                    nextElement='typography'>
                    Get your tailored recommendations
                  </TypographyStyled>
                  <Typography disableBottomPadding>
                    Your advisor will{' '}
                    <Link
                      id='working-with-an-advisor-design-plan-link'
                      linkUrl='/financial-planning/'
                      variant='primaryDeemphasize'>
                      design a plan
                    </Link>
                    {' '}&#40;at no cost to you&#41; tailored from a range of top&#45;rated financial options designed to give you the flexibility and confidence to reach your goals now and later on.
                  </Typography>
                </>
              ),
            },
            ]}
            bulletType='checkmark' />
        </>
      )}
      // image props
      imageAltText='An expecting couple on looking at a computer.'
      imageSrcDefault={ExpectingCoupleDesktopWebp.toString()}
      imageSrcMobile={ExpectingCoupleMobileWebp.toString()}
    />
  );
};
